import { useCallback } from "react";
import { useGenerationPhase, type GenerationPhase } from "./useGenerationPhase";

export type GenerateTopicPhase = GenerationPhase;

type Result = { postId: string };

interface UseGenerateWithTopic {
  generate: (topic: string) => void;
  phase: GenerateTopicPhase;
  result: Result | null;
  error: string | null;
  reset: () => void;
}

export const useGenerateWithTopic = (): UseGenerateWithTopic => {
  const { start, phase, result, error, reset } = useGenerationPhase<Result>({
    action: "generate-with-topic",
    parseResult: (msg) => ({ postId: msg.postId as string }),
  });

  const generate = useCallback(
    (topic: string) => {
      start({ topic });
    },
    [start]
  );

  return { generate, phase, result, error, reset };
};
